import { createStore } from 'vuex';

export let initialState = {
  visible: false,
  specs: {
    unitType: null,
    outerDiameter: null,
    materialType: null,
    wireDiameter: null,
    overallLength: null,
    SBC: null,
    endType: null,
    TQ1: null,
    TQ2: null,
    TQ3: null,
    TQ4: null,
  },
  showHeaderText: false,
  quoteId: null,
  loading: false,
  leadTime: '',
  quoteFormVisible: false,
  braintreeErrorMessage: '',
  launchFocus: false,
  quotes: [
    /*
      { 
        quantity: null,
        price: null,
        total: null 
      }

      */
  ],
  order: {
    item: {
      price: null, //0
      quantity: null, //0
      total: null, //0
      index: null, // index of the qty selected
      leadTime: null
    },
    customer: {
      firstname: '',
      lastname: '',
      company: '',
      email: '',
      phone: '',
    },
    shipping: {
      address: '',
      city: '',
      state: '',
      zip: ''
    },
    billing: {
      address: '',
      city: '',
      state: '',
      zip: ''
    }
  }
};

export default createStore({
    state () {
      return initialState;
    },
    getters: {
      specsValid(state) {
        if (state.specs.unitType == 'Metric (mm)') {
          return state.specs.unitType != null &&
          state.specs.outerDiameter != null &&
          state.specs.materialType != null &&
          state.specs.wireDiameter != null &&
          state.specs.overallLength != null &&
          state.specs.SBC != null &&
          state.specs.endType != null &&
          state.specs.TQ1 != null &&
          state.specs.TQ1 < 1001 &&
          state.specs.TQ2 < 1001 &&
          state.specs.TQ3 < 1001 &&
          state.specs.TQ4 < 1001 && 
          state.specs.outerDiameter <= 95.25 &&
          state.specs.wireDiameter < 10 &&
          state.specs.overallLength <= 1828.8 &&
          state.specs.SBC < 10 &&
          state.specs.outerDiameter >= 2.2352 &&
          state.specs.wireDiameter > 0.0001 &&
          state.specs.overallLength >= 0 &&
          state.specs.SBC > 0;
        } else {
          return state.specs.unitType != null &&
          state.specs.outerDiameter != null &&
          state.specs.materialType != null &&
          state.specs.wireDiameter != null &&
          state.specs.overallLength != null &&
          state.specs.SBC != null &&
          state.specs.endType != null &&
          state.specs.TQ1 != null &&
          state.specs.TQ1 < 1001 &&
          state.specs.TQ2 < 1001 &&
          state.specs.TQ3 < 1001 &&
          state.specs.TQ4 < 1001 && 
          state.specs.outerDiameter <= 3.750 &&
          state.specs.wireDiameter < 10 &&
          state.specs.overallLength <= 72 &&
          state.specs.SBC < 10 &&
          state.specs.outerDiameter >= 0.088 &&
          state.specs.wireDiameter > 0.0001 &&
          state.specs.overallLength >= 0 &&
          state.specs.SBC > 0;
        }
      },
      quotes(state) {
        return state.quotes.length > 0 ? state.quotes : [
            { 
                quantity: null,
                price: null,
                total: null 
            },
            { 
                quantity: null,
                price: null,
                total: null 
            },
            { 
                quantity: null,
                price: null,
                total: null 
            },
            { 
                quantity: null,
                price: null,
                total: null 
            }
        ]
      }
    },
    mutations: {
      show (state) {
        state.visible = true;
        document.body.style.overflow = 'hidden';
      },
      hide (state) {
        state.visible = false;
        document.body.style.overflow = 'auto';
      },
      updateHeaderText(state, value) {
        state.showHeaderText = value;
      },
      updateSpecs (state, value) {
        state.specs = value;
      },
      patch(state,value) {
        state = {...state,...value}
      },
      updateQuotes(state, value) {
        state.quotes = value;
      },
      updating(state, value) {
        state.loading = value;
      },
      updateItem(state, value) {
        state.order.item = value;
      },
      updateOrder(state, value) {
        
      },
      updateQuoteId(state, value) {
        state.quoteId = value;
      },
      toggleQuote(state) {
        state.quoteFormVisible = !state.quoteFormVisible;
      },
      updateBraintreeError(state, value) {
        state.braintreeErrorMessage = value;
      },
      updateSpecsValid(state, value) {
        state.specsValid = value;
      },
      updateLeadTime(state, value) {
        state.leadTime = value;
      },
      updateLaunchFocus(state, value) {
        state.launchFocus = value;
      }
    }
  });

